import React from 'react'
import { ApolloError } from '@apollo/client'
import { Order, useOrdersAndSubscriptions } from '@/services/PaymentsService'
import type { Subscription } from '@/services/PaymentsService'
import { ReactFCC } from '@/types/react'

interface PaymentContextProps {
  children: React.ReactNode
}

interface PaymentContextType {
  loading: boolean
  error?: ApolloError
  payments: Array<Order>
  refetch: () => Promise<unknown>
  subscriptions: Array<Subscription>
  startPolling: (interval: number) => void
  stopPolling: () => void
}

const PaymentContext = React.createContext<PaymentContextType>({
  loading: true,
  error: undefined,
  payments: [],
  refetch: () => Promise.resolve(),
  subscriptions: [],
  startPolling: () => {},
  stopPolling: () => {},
})

export const PaymentsContextProvider: ReactFCC<PaymentContextProps> = ({ children }) => {
  const { data, error, loading, refetch, startPolling, stopPolling } = useOrdersAndSubscriptions()

  const payments = data?.orders || []
  const subscriptions = data?.marketSubscriptions || []

  const value = {
    loading,
    error,
    payments,
    subscriptions,
    refetch,
    startPolling,
    stopPolling,
  }

  return <PaymentContext.Provider value={value}>{children}</PaymentContext.Provider>
}

export function usePaymentsContext() {
  return React.useContext(PaymentContext)
}
